import React from "react";
import Tracking from "../../components/RoleBased/Tracking";
import { getCurrentUser } from '../../reducers/login'
import { connect } from "react-redux";

const TrackingContainer = props => <Tracking {...props} />;

const mapState = (state, props) => ({
    currentUser: getCurrentUser(state),
});

const actions = (dispatch, props) => ({
});

export default connect(mapState, actions)(TrackingContainer);